<template>
  <ContentDrawer :overlay="true" :value="value" @input="$emit('input',$event)" @close="close()">
        <h1>{{$ta(measuresection.title_textassetid)}}</h1>
        <ContentRenderer ref="contentrenderer" :content="measuresection.content" :framework-controls="false" :mini="true" :hidden="!value"></ContentRenderer>
  </ContentDrawer>
</template>

<script>
  import ContentRenderer from "../../../content/ContentRenderer";
  import ContentDrawer from "../../../framework/drawer/ContentDrawer";
  export default {
    name: "MeasureSection",
    components:{
      ContentRenderer,
      ContentDrawer
    },
    props:{
      measuresection:{type:Object,required:true},
      value:{}
    },
    methods:{
      close(){
        this.$refs.contentrenderer.pauseAllMedia();
      }
    }
  }
</script>

<style scoped>

</style>